import { FC } from "react";
import { ShareIssueModel } from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { Box } from "@/components-v2/Box";
import { LinkButton } from "@/components-v2/Button";
import { useRootStore, useTranslation } from "@/stores/RootStoreContext";
import { NewShareClassDialog } from "@/shareholderRegister/transactions/commonTransactionComponents";

const NewShareType: FC<{ model: ShareIssueModel }> = observer(({ model }) => {
  const { http } = useRootStore();
  const { t, lang } = useTranslation();
  return (
    <Box>
      <LinkButton
        label={t("decisions.increaseShareCapitalAgainstCash.addNewShareType")}
        icon={"plus"}
        disabled={model.isProjectLocked}
        onClick={() => model.openNewSharetypeDialog(http, lang)}
      />
      {model.newShareClassController && (
        <NewShareClassDialog controller={model.newShareClassController} />
      )}
    </Box>
  );
});

export default NewShareType;
